import { create } from "zustand";
import { persist } from "zustand/middleware";

type OrderUuidStore = {
  orderUuid: string;
  orderUuidTimestamp: number | null;
  setOrderUuid: (uuid: string) => void;
  hydrated: boolean;
  setHydrated: () => void;
};

export const useOrderUuidStore = create<OrderUuidStore>()(
  persist(
    (set, get) => ({
      orderUuid: "", // Default UUID
      orderUuidTimestamp: null,
      setOrderUuid: (uuid) => {
        set({ orderUuid: uuid, orderUuidTimestamp: Date.now() });
      },
      hydrated: false,
      setHydrated: () => set({ hydrated: true }),
    }),
    {
      name: "new-order-uuid",
      onRehydrateStorage: () => (state) => {
        state?.setHydrated();
      },
    }
  )
);

export const useOrderUuid = () => useOrderUuidStore((state) => state.orderUuid);
export const useOrderUuidTimestamp = () =>
  useOrderUuidStore((state) => state.orderUuidTimestamp);
export const useOrderUuidAge = () => {
  const timestamp = useOrderUuidStore((state) => state.orderUuidTimestamp);
  const age = timestamp ? Date.now() - timestamp : null;
  if (age !== null) {
    const seconds = Math.floor(age / 1000);
    const minutes = Math.floor(seconds / 60);
    console.log(`seconds: ${seconds}, minutes: ${minutes}`);
  }
  return age;
};
export const useSetOrderUuid = () =>
  useOrderUuidStore((state) => state.setOrderUuid);
export const useHasOrderUuidHydrated = () =>
  useOrderUuidStore((state) => state.hydrated);
export const invalidateOrderUuidStore = () =>
  useOrderUuidStore.persist.clearStorage();
